import { gameControllers } from "./helper_object";

export function animateCanvas(canvas, game, ctx, timeStamp, animateFunction) {
  if (game.remainingLives === 0) game.gameOver = true;
  if (game?.gameOver) return;

  const deltaTime = timeStamp - gameControllers.lastAnimationFrameTime;
  gameControllers.lastAnimationFrameTime = timeStamp;
  
  if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
  
  game.delta = deltaTime;
  game.update(deltaTime);
  game.draw();
  requestAnimationFrame((timeStamp) =>
    animateFunction(canvas, game, ctx, timeStamp, animateFunction)
  );
}
